import { Fragment } from 'react';

import { useFormikContext } from 'formik';
import moment, { Moment } from 'moment';
import { useSelector } from 'react-redux';

import DatePicker, { IDatePickerProps } from '../../../components/common/DatePicker/DatePicker';
import { DropDownFilterButtonSize } from '../../../components/common/DropDownFilter/DropDownFilter';
import { FormLabelStyled } from '../../../components/common/FormStyled/FormStyled';
import { LabelMarkStyled } from '../../../components/common/Input/styled/InputStyled';
import { makeSelectTranslationCommon } from '../../internationalization/intSelectors';
import FormField, { IFormFieldProps } from './FormField';

type TFormFieldDateProps = IFormFieldProps & Partial<IDatePickerProps>;

const FormFieldDate = (props: TFormFieldDateProps) => {
    const translationCommon = useSelector(makeSelectTranslationCommon());

    const { setFieldTouched, setFieldValue, validateField } = useFormikContext();

    return (
        <FormField {...props}>
            {({ field, label, dataName, required, kind }) => {
                const onSelectDate = (date: Moment) => {
                    props.onSelectDate?.(date);
                    setFieldValue(field.name, date.utc(true).toISOString());
                    setTimeout(() => {
                        validateField(field.name);
                    });
                };

                return (
                    <Fragment>
                        <FormLabelStyled>
                            {label}
                            {required && <LabelMarkStyled>*</LabelMarkStyled>}
                        </FormLabelStyled>
                        <DatePicker
                            isCurrentPeriod
                            additionalButtons={props.additionalButtons}
                            dataName={dataName}
                            disabled={props.disabled}
                            filterButtonSize={DropDownFilterButtonSize.medium}
                            headType={props.headType}
                            kind={kind}
                            label=" "
                            maxDate={props.maxDate}
                            minDate={props.minDate}
                            selectedDate={field.value ? moment(field.value) : undefined}
                            translation={translationCommon}
                            onCloseClick={() => setFieldTouched(field.name)}
                            onSelectDate={onSelectDate}
                        />
                    </Fragment>
                );
            }}
        </FormField>
    );
};

export default FormFieldDate;
